import { Injectable } from '@angular/core'
import { Router, UrlTree } from '@angular/router'
import { Observable } from 'rxjs'
import { environment } from '../../environments/environment'

@Injectable({
  providedIn: 'root',
})
export class DigitalSubscriptionContentGuard  {
  constructor(readonly router: Router) {}

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return environment.digitalContent ? true : this.router.parseUrl('/navigation')
  }
}
